import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionService } from '../tipo-revision.service';

@Component({
  selector: 'app-tipo-revision-create',
  templateUrl: './tipo-revision-create.component.html',
  styleUrls: ['./tipo-revision-create.component.scss']
})
export class TipoRevisionCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});
  
  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: TipoRevisionService,
    public formatter: FormatterService
  ) {}
  
  ngOnInit() {
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: [''],
    });
  }
  
  guardar(){
    if(this.form.valid){
      this.loading.show();
      this.service.create(this.form.value).subscribe((res: any) => {
        this.loading.hide();
        this.activeModal.close(res.model);
      }, (err: any) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el tipo.", "danger");
      })
    } else {
      this.form.markAllAsTouched();
    }
  }

}
